import type { ReactNode } from 'react'
import { motion } from 'framer-motion'
import { useNavigate, Link } from 'react-router-dom'
import bg1 from '@/assets/images/bg1.webp'
import bg2 from '@/assets/images/bg2.webp'
import callImg from '@/assets/images/call.webp'

// ─── Brand icon SVGs ──────────────────────────────────────────────────────────
const GithubIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6496 0.00012207C7.45519 0.00012207 0 7.21844 0 16.1231C0 23.2463 4.77088 29.2899 11.3857 31.4217C12.2181 31.5713 12.5238 31.0721 12.5238 30.6464C12.5238 30.2619 12.5084 28.9917 12.5009 27.6444C7.86898 28.6199 6.89186 25.7424 6.89186 25.7424C6.13421 23.879 5.04306 23.3832 5.04306 23.3832C3.53217 22.3826 5.15688 22.4029 5.15688 22.4029C6.82878 22.5169 7.70885 24.0646 7.70885 24.0646C9.19415 26.5294 11.6041 25.8169 12.5543 25.4049C12.7038 24.363 13.135 23.6513 13.6112 23.2489C9.9132 22.8418 6.02591 21.459 6.02591 15.2811C6.02591 13.5211 6.67615 12.0826 7.74105 10.9537C7.56835 10.5475 6.9984 8.90752 7.90273 6.68681C7.90273 6.68681 9.30069 6.25322 12.4817 8.33937C13.8102 7.98224 15.2344 7.80325 16.6493 7.79684C18.0643 7.80325 19.4898 7.98224 20.8203 8.33937C23.9982 6.25343 25.3944 6.6866 25.3944 6.6866C26.3005 8.90709 25.7308 10.547 25.5576 10.9531C26.6252 12.0821 27.271 13.5205 27.271 15.2804C27.271 21.4735 23.3762 22.8367 19.6689 23.2359C20.266 23.7365 20.7982 24.7175 20.7982 26.2219C20.7982 28.3791 20.7793 30.1156 20.7793 30.6464C20.7793 31.0757 21.0786 31.5781 21.9225 31.42C28.5351 29.2858 33.2994 23.2444 33.2994 16.1233C33.2994 7.21844 25.8439 0.00012207 16.6496 0.00012207Z"
      fill="#292929"
    />
    <path
      d="M6.30544 23.1476C6.26861 23.2279 6.13847 23.2523 6.02002 23.1967C5.89871 23.1442 5.83143 23.0348 5.87048 22.9545C5.90643 22.8723 6.03657 22.8494 6.15722 22.9043C6.27809 22.9571 6.34691 23.0673 6.30544 23.1476ZM6.97796 23.8764C6.89856 23.9477 6.74305 23.9148 6.63828 23.8021C6.52888 23.6895 6.50881 23.5389 6.58932 23.4667C6.67093 23.3956 6.8218 23.4289 6.93054 23.5415C7.03972 23.6551 7.06112 23.8042 6.97796 23.8764ZM7.63438 24.8055C7.53226 24.8745 7.36528 24.8102 7.26206 24.6667C7.15993 24.5231 7.15993 24.3512 7.26426 24.2822C7.36793 24.2134 7.53225 24.2758 7.63703 24.4176C7.73849 24.5635 7.73849 24.7352 7.63438 24.8055ZM8.53585 25.7028C8.44454 25.8002 8.25021 25.774 8.10794 25.6409C7.96237 25.511 7.92178 25.3265 8.0131 25.2291C8.10574 25.1315 8.30116 25.1586 8.44454 25.291C8.58901 25.4205 8.6329 25.6063 8.53585 25.7028ZM9.77656 26.2234C9.73598 26.3494 9.54937 26.407 9.36057 26.353C9.17198 26.2979 9.04868 26.1501 9.08706 26.0226C9.12588 25.8955 9.31425 25.8357 9.50394 25.8931C9.69208 25.948 9.81582 26.095 9.77656 26.2234ZM11.1386 26.3195C11.143 26.4525 10.9833 26.563 10.7857 26.5651C10.5863 26.5694 10.425 26.4617 10.4228 26.331C10.4228 26.1964 10.5794 26.0875 10.778 26.0843C10.9765 26.08 11.1386 26.1875 11.1386 26.3193M12.4069 26.1112C12.4305 26.2407 12.2931 26.3739 12.0963 26.4094C11.9031 26.444 11.7242 26.3637 11.6997 26.2353C11.6755 26.1023 11.8155 25.9692 12.0085 25.9348C12.2055 25.9015 12.3817 25.9794 12.4069 26.1112Z"
      fill="#292929"
    />
  </svg>
)
const VSCodeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <g clipPath="url(#clip0_840_1864)">
      <path
        d="M31.4497 3.27273V28.177L23.5873 31.4497L0 23.5086L23.5873 27.0271V0L31.4497 3.27273ZM1.96561 17.8133L6.38822 13.4398L1.96561 9.06636L3.75922 8.46685L8.10812 11.7445L15.3317 4.60443L19.6561 6.44227V20.4374L15.3317 22.2752L8.10812 15.1352L3.75922 18.4128L1.96561 17.8133ZM10.3587 13.4398L15.3317 17.1991V9.69535L10.3587 13.4398Z"
        fill="#007ACC"
      />
    </g>
    <defs>
      <clipPath id="clip0_840_1864">
        <rect width="31.4497" height="31.4497" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
const FigmaIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="32" viewBox="0 0 21 32" fill="none">
    <g clipPath="url(#clip0_840_1875)">
      <path
        d="M5.24162 31.4491C8.13499 31.4491 10.4832 29.1008 10.4832 26.2074V20.9658H5.24162C2.34824 20.9658 0 23.3141 0 26.2074C0 29.1008 2.34824 31.4491 5.24162 31.4491Z"
        fill="#0ACF83"
      />
      <path
        d="M0 15.725C0 12.8316 2.34824 10.4834 5.24162 10.4834H10.4832V20.9666H5.24162C2.34824 20.9666 0 18.6184 0 15.725Z"
        fill="#A259FF"
      />
      <path
        d="M0 5.24162C0 2.34824 2.34824 0 5.24162 0H10.4832V10.4832H5.24162C2.34824 10.4832 0 8.13499 0 5.24162Z"
        fill="#F24E1E"
      />
      <path
        d="M10.4844 -0.000244141H15.726C18.6194 -0.000244141 20.9676 2.348 20.9676 5.24137C20.9676 8.13474 18.6194 10.483 15.726 10.483H10.4844V-0.000244141Z"
        fill="#FF7262"
      />
      <path
        d="M20.9676 15.7248C20.9676 18.6181 18.6194 20.9664 15.726 20.9664C12.8326 20.9664 10.4844 18.6181 10.4844 15.7248C10.4844 12.8314 12.8326 10.4832 15.726 10.4832C18.6194 10.4832 20.9676 12.8314 20.9676 15.7248Z"
        fill="#1ABCFE"
      />
    </g>
    <defs>
      <clipPath id="clip0_840_1875">
        <rect width="20.9665" height="31.4497" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
const NotionIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="32" viewBox="0 0 31 32" fill="none">
    <path
      d="M5.2023 5.51385C6.17986 6.30796 6.54678 6.24768 8.38396 6.1245L25.7009 5.08535C26.0679 5.08535 25.7625 4.71844 25.6407 4.65816L22.763 2.57855C22.2127 2.15136 21.4775 1.66127 20.0701 1.78313L3.30353 3.00705C2.69288 3.06733 2.5697 3.37396 2.81344 3.6177L5.2023 5.51385ZM6.24145 9.5499V27.7698C6.24145 28.7486 6.73023 29.1155 7.83228 29.0539L26.8633 27.9532C27.9653 27.8929 28.0885 27.2194 28.0885 26.424V8.32598C28.0885 7.53188 27.7832 7.10337 27.1083 7.16365L7.22033 8.32598C6.4865 8.38757 6.24145 8.75579 6.24145 9.5499ZM25.0287 10.5261C25.1506 11.0765 25.0287 11.6269 24.4783 11.6898L23.5611 11.8732V25.3232C22.7643 25.7517 22.0305 25.9968 21.4186 25.9968C20.4384 25.9968 20.1933 25.6901 19.4595 24.7742L13.4618 15.3576V24.4675L15.3592 24.8973C15.3592 24.8973 15.3592 25.9981 13.8287 25.9981L9.60657 26.2418C9.4847 25.9981 9.60657 25.3861 10.0351 25.2643L11.1358 24.9589V12.9124L9.60919 12.7892C9.48601 12.2388 9.79265 11.4447 10.6483 11.3832L15.1771 11.0778L21.4199 20.6163V12.1773L19.8277 11.9951C19.7059 11.3216 20.1946 10.8328 20.8066 10.7725L25.0287 10.5261ZM1.89615 1.35594L19.3376 0.0717472C21.4788 -0.111709 22.0305 0.0101582 23.3763 0.98903L28.9442 4.9019C29.8615 5.57413 30.1681 5.75759 30.1681 6.49142V27.9532C30.1681 29.2977 29.6793 30.0944 27.9666 30.215L7.71042 31.4389C6.42622 31.5005 5.81295 31.317 5.1394 30.46L1.03915 25.1398C0.305324 24.1609 0 23.4284 0 22.5714V3.49452C0 2.39509 0.490091 1.4765 1.89615 1.35594Z"
      fill="black"
    />
  </svg>
)
const SlackIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M6.62607 19.8813C6.62607 21.7092 5.14874 23.1865 3.32085 23.1865C1.49296 23.1865 0.015625 21.7092 0.015625 19.8813C0.015625 18.0534 1.49296 16.576 3.32085 16.576H6.62607V19.8813ZM8.27868 19.8813C8.27868 18.0534 9.75601 16.576 11.5839 16.576C13.4118 16.576 14.8891 18.0534 14.8891 19.8813V28.1443C14.8891 29.9722 13.4118 31.4496 11.5839 31.4496C9.75601 31.4496 8.27868 29.9722 8.27868 28.1443V19.8813Z"
      fill="#E01E5A"
    />
    <path
      d="M11.5933 6.61044C9.76543 6.61044 8.2881 5.13311 8.2881 3.30522C8.2881 1.47733 9.76543 0 11.5933 0C13.4212 0 14.8985 1.47733 14.8985 3.30522V6.61044H11.5933ZM11.5933 8.2881C13.4212 8.2881 14.8985 9.76543 14.8985 11.5933C14.8985 13.4212 13.4212 14.8985 11.5933 14.8985H3.30522C1.47733 14.8985 0 13.4212 0 11.5933C0 9.76543 1.47733 8.2881 3.30522 8.2881H11.5933Z"
      fill="#36C5F0"
    />
    <path
      d="M24.8412 11.5933C24.8412 9.76543 26.3185 8.2881 28.1464 8.2881C29.9743 8.2881 31.4516 9.76543 31.4516 11.5933C31.4516 13.4212 29.9743 14.8985 28.1464 14.8985H24.8412V11.5933ZM23.1886 11.5933C23.1886 13.4212 21.7112 14.8985 19.8833 14.8985C18.0555 14.8985 16.5781 13.4212 16.5781 11.5933V3.30522C16.5781 1.47733 18.0555 0 19.8833 0C21.7112 0 23.1886 1.47733 23.1886 3.30522V11.5933Z"
      fill="#2EB67D"
    />
    <path
      d="M19.8833 24.8391C21.7112 24.8391 23.1886 26.3164 23.1886 28.1443C23.1886 29.9722 21.7112 31.4496 19.8833 31.4496C18.0555 31.4496 16.5781 29.9722 16.5781 28.1443V24.8391H19.8833ZM19.8833 23.1865C18.0555 23.1865 16.5781 21.7092 16.5781 19.8813C16.5781 18.0534 18.0555 16.576 19.8833 16.576H28.1714C29.9993 16.576 31.4767 18.0534 31.4767 19.8813C31.4767 21.7092 29.9993 23.1865 28.1714 23.1865H19.8833Z"
      fill="#ECB22E"
    />
  </svg>
)
const WordPressIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <g clipPath="url(#clip0_840_1913)">
      <path
        d="M9.43377 9.70576H7.69702L12.4319 23.0901L15.0826 15.5153L13.0275 9.70576H11.195V8.43042H19.3096V9.70576H17.4094L22.1442 23.0901L23.8462 18.2263C26.0788 11.9949 22.0163 10.0538 22.0163 8.66309C22.0163 7.2724 23.1437 6.14507 24.5343 6.14507C24.6095 6.14507 24.6826 6.14915 24.7542 6.15582C22.3979 3.93145 19.2206 2.56738 15.7245 2.56738C11.1563 2.56738 7.13234 4.89593 4.77344 8.43042H9.43363V9.70576H9.43377Z"
        fill="#00769D"
      />
      <path
        d="M2.57031 15.7252C2.57031 20.7625 5.40158 25.1379 9.55912 27.3488L3.62148 10.5645C2.9451 12.149 2.57031 13.8933 2.57031 15.7252Z"
        fill="#00769D"
      />
      <path
        d="M27.1805 9.24121C27.3687 10.3494 27.3117 11.5948 27.0229 12.8452H27.0752L26.8763 13.4136C26.7584 13.8241 26.6099 14.244 26.4413 14.6566L21.9141 27.3398C26.0629 25.1262 28.8869 20.7555 28.8869 15.7246C28.8869 13.3672 28.2663 11.1549 27.1805 9.24121Z"
        fill="#00769D"
      />
      <path
        d="M11.6719 28.2435C12.9501 28.6576 14.3135 28.8822 15.7297 28.8822C17.0805 28.8822 18.3836 28.6783 19.6103 28.3002L15.7617 17.4209L11.6719 28.2435Z"
        fill="#00769D"
      />
      <path
        d="M26.8439 4.60568C23.8739 1.63566 19.925 0 15.7248 0C11.5245 0 7.57569 1.63566 4.60568 4.60568C1.63566 7.57569 0 11.5245 0 15.7248C0 19.9251 1.63566 23.8739 4.60568 26.8439C7.57569 29.814 11.5246 31.4496 15.7248 31.4496C19.9251 31.4496 23.8739 29.814 26.844 26.8439C29.814 23.8739 31.4497 19.925 31.4497 15.7248C31.4496 11.5245 29.814 7.57569 26.8439 4.60568ZM15.7248 30.3404C7.66575 30.3404 1.10927 23.7839 1.10927 15.7248C1.10927 7.66582 7.66575 1.10927 15.7248 1.10927C23.7838 1.10927 30.3403 7.66582 30.3403 15.7248C30.3403 23.7839 23.7839 30.3404 15.7248 30.3404Z"
        fill="#00769D"
      />
    </g>
    <defs>
      <clipPath id="clip0_840_1913">
        <rect width="31.4497" height="31.4497" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
const ZapIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M6.1465 20.8426L12.3089 17.3847L12.412 17.0833L12.3089 16.9168H12.0075L10.9765 16.8533L7.45511 16.7581L4.40169 16.6312L1.44344 16.4726L0.697925 16.314L0 15.394L0.0713787 14.934L0.697925 14.5137L1.59412 14.593L3.57687 14.7278L6.55098 14.934L8.7082 15.0609L11.9044 15.394H12.412L12.4833 15.1878L12.3089 15.0609L12.174 14.934L9.09682 12.8482L5.76581 10.6434L4.021 9.3744L3.07722 8.73199L2.60136 8.12924L2.39515 6.8127L3.2517 5.86892L4.40169 5.94823L4.69513 6.02753L5.86098 6.92373L8.35131 8.85096L11.603 11.2461L12.0789 11.6427L12.2692 11.5078L12.293 11.4127L12.0789 11.0558L10.3103 7.85959L8.42269 4.60789L7.582 3.25963L7.35994 2.45067C7.28063 2.11757 7.22511 1.83998 7.22511 1.49895L8.20062 0.174481L8.73993 0L10.0406 0.174481L10.5878 0.650339L11.3968 2.49825L12.7054 5.40892L14.7357 9.36647L15.3306 10.5403L15.6478 11.6268L15.7668 11.9599H15.973V11.7696L16.1395 9.54095L16.4488 6.80477L16.7502 3.28342L16.8533 2.29205L17.345 1.1024L18.3205 0.459996L19.0819 0.824821L19.7085 1.72102L19.6212 2.29998L19.2485 4.71893L18.5188 8.50993L18.0429 11.0478H18.3205L18.6378 10.7306L19.9226 9.02544L22.0798 6.32891L23.0315 5.25823L24.1419 4.07652L24.8557 3.51342H26.2039L27.1953 4.98858L26.7512 6.51132L25.3632 8.272L24.2132 9.76302L22.5636 11.9837L21.5326 13.7602L21.6277 13.903L21.8736 13.8792L25.6012 13.0861L27.6156 12.7213L30.0187 12.3089L31.1053 12.8164L31.2242 13.332L30.7959 14.3868L28.2263 15.0213L25.2125 15.624L20.7236 16.6868L20.6681 16.7264L20.7315 16.8057L22.7539 16.9961L23.6184 17.0436H25.736L29.6777 17.3371L30.7087 18.0192L31.3273 18.8519L31.2242 19.4864L29.638 20.2953L27.4967 19.7878L22.5002 18.5981L20.7871 18.1698H20.5491V18.3126L21.9767 19.7085L24.5939 22.0719L27.8694 25.1174L28.036 25.8708L27.6156 26.4656L27.1715 26.4022L24.2926 24.237L23.1822 23.2615L20.6681 21.144H20.5016V21.366L21.0805 22.2146L24.1419 26.8146L24.3005 28.2263L24.0784 28.6863L23.2853 28.9639L22.4129 28.8053L20.6205 26.2912L18.7726 23.4598L17.2816 20.9219L17.0992 21.025L16.2188 30.5025L15.8064 30.9863L14.8547 31.3511L14.0616 30.7484L13.6413 29.7729L14.0616 27.8456L14.5692 25.3315L14.9816 23.3329L15.3544 20.8505L15.5764 20.0257L15.5606 19.9702L15.3781 19.994L13.5064 22.5636L10.6592 26.4101L8.40683 28.8211L7.86752 29.0353L6.93167 28.5515L7.01891 27.687L7.54235 26.9177L10.6592 22.9522L12.5389 20.4936L13.7523 19.074L13.7444 18.8678H13.673L5.39306 24.245L3.9179 24.4353L3.28342 23.8405L3.36273 22.865L3.66411 22.5477L6.15443 20.8347L6.1465 20.8426Z"
      fill="#D97757"
    />
  </svg>
)
const GoogleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="18" viewBox="0 0 31 18" fill="none">
    <g clipPath="url(#clip0_840_1831)">
      <path
        d="M30.7159 16.0182C30.7159 14.7298 30.6113 13.7895 30.385 12.8145H15.6719V18.63H24.3082C24.1341 20.0753 23.1939 22.2518 21.1044 23.7143L21.0751 23.909L25.7271 27.5129L26.0494 27.545C29.0094 24.8113 30.7159 20.7891 30.7159 16.0182Z"
        fill="#4285F4"
      />
      <path
        d="M6.7558 18.7707C6.42498 17.7956 6.23352 16.7508 6.23352 15.6713C6.23352 14.5917 6.42498 13.547 6.7384 12.5719L6.72963 12.3643L1.83176 8.56055L1.67152 8.63677C0.609428 10.7611 0 13.1466 0 15.6713C0 18.196 0.609428 20.5814 1.67152 22.7057L6.7558 18.7707Z"
        fill="#FBBC05"
      />
      <path
        d="M15.6634 6.05935C18.606 6.05935 20.5909 7.33042 21.7227 8.39263L26.1454 4.07442C23.4292 1.54968 19.8944 0 15.6634 0C9.53429 0 4.24102 3.5172 1.66406 8.6363L6.73094 12.5715C8.00214 8.79307 11.5193 6.05935 15.6634 6.05935Z"
        fill="#EB4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_840_1831">
        <rect width="30.7295" height="31.4497" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
const CubeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="18" viewBox="0 0 32 18" fill="none">
    <g clipPath="url(#clip0_840_1857)">
      <path
        d="M19.6559 15.7317C19.6565 16.8657 19.4519 17.9905 19.0521 19.0516C17.9906 19.4514 16.8656 19.6562 15.7312 19.6564H15.718C14.5499 19.655 13.4307 19.4414 12.3981 19.0521C11.998 17.9908 11.7933 16.8659 11.7936 15.7317V15.718C11.7931 14.5842 11.9974 13.4596 12.3968 12.3986C13.4583 11.9981 14.5836 11.7931 15.7181 11.7936H15.7314C16.8658 11.7931 17.9909 11.998 19.0522 12.3984C19.4521 13.4594 19.6566 14.584 19.6561 15.7178V15.7316L19.6559 15.7317ZM31.2313 13.1041H22.0524L28.5424 6.61353C28.033 5.89794 27.4648 5.22612 26.8437 4.60505V4.60455C26.2225 3.98415 25.5509 3.41643 24.8357 2.90725L18.3451 9.39781V0.218919C17.4819 0.0737014 16.6081 0.000476278 15.7327 0L15.7165 0C14.8261 0.000491401 13.954 0.0761672 13.1041 0.218919V9.39781L6.61353 2.90725C5.89822 3.41629 5.22687 3.98441 4.60652 4.60566L4.60308 4.60812C3.983 5.22842 3.41556 5.8992 2.90664 6.61353L9.39768 13.1041H0.218919C0.218919 13.1041 0 14.828 0 15.7194V15.7303C0 16.6217 0.075553 17.4952 0.218919 18.3456H9.39781L2.90676 24.8362C3.92785 26.2691 5.1806 27.5218 6.61353 28.5429L13.1041 22.0519V31.2313C13.9664 31.3758 14.8391 31.4488 15.7134 31.4497H15.7357C16.61 31.4489 17.4827 31.3758 18.345 31.2313V22.0519L24.8362 28.5429C25.5512 28.0336 26.2227 27.4657 26.8437 26.8451L26.8451 26.8437C27.4654 26.2226 28.0331 25.5511 28.5424 24.8362L22.0514 18.3456H31.2313C31.3741 17.4967 31.4487 16.6257 31.4497 15.7363V15.7134C31.4487 14.824 31.3741 13.953 31.2313 13.1041Z"
        fill="#FF4A00"
      />
    </g>
    <defs>
      <clipPath id="clip0_840_1857">
        <rect width="31.4497" height="31.4497" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
const SparkleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="32" viewBox="0 0 31 32" fill="none">
    <g clipPath="url(#clip0_840_1905)">
      <path
        d="M17.8906 30.9215C17.0873 31.933 15.4586 31.3788 15.4393 30.0872L15.1562 11.1953H27.8591C30.1599 11.1953 31.4431 13.8528 30.0124 15.6547L17.8906 30.9215Z"
        fill="url(#paint0_linear_840_1905)"
      />
      <path
        d="M17.8906 30.9215C17.0873 31.933 15.4586 31.3788 15.4393 30.0872L15.1562 11.1953H27.8591C30.1599 11.1953 31.4431 13.8528 30.0124 15.6547L17.8906 30.9215Z"
        fill="url(#paint1_linear_840_1905)"
        fillOpacity="0.2"
      />
      <path
        d="M12.7233 0.522458C13.5265 -0.489226 15.1553 0.0651035 15.1746 1.35676L15.2986 20.2486H2.75478C0.453879 20.2486 -0.829373 17.5911 0.601393 15.7891L12.7233 0.522458Z"
        fill="#3ECF8E"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_840_1905"
        x1="18.381"
        y1="15.3841"
        x2="25.6649"
        y2="18.439"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#249361" />
        <stop offset="1" stopColor="#3ECF8E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_840_1905"
        x1="15.464"
        y1="8.53093"
        x2="20.14"
        y2="17.3332"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_840_1905">
        <rect width="30.6126" height="31.4497" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
const CursorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="33" viewBox="0 0 29 33" fill="none">
    <path
      d="M28.0608 7.72588L14.9938 0.181733C14.5742 -0.0605777 14.0565 -0.0605777 13.6369 0.181733L0.570504 7.72588C0.217773 7.92954 0 8.30619 0 8.71414V23.927C0 24.3349 0.217773 24.7115 0.570504 24.9152L13.6375 32.4594C14.0571 32.7017 14.5748 32.7017 14.9944 32.4594L28.0614 24.9152C28.4141 24.7115 28.6319 24.3349 28.6319 23.927V8.71414C28.6319 8.30619 28.4141 7.92954 28.0614 7.72588H28.0608ZM27.24 9.3239L14.6257 31.1723C14.5405 31.3196 14.3153 31.2595 14.3153 31.0889V16.7828C14.3153 16.4969 14.1626 16.2325 13.9148 16.089L1.52564 8.9362C1.37841 8.85093 1.43853 8.6258 1.60907 8.6258H26.8376C27.1958 8.6258 27.4197 9.01411 27.2406 9.32451H27.24V9.3239Z"
      fill="#26251E"
    />
  </svg>
)

// ─── Grid definition (9 cols × 5 rows = 45 cells) ────────────────────────────
// null = invisible spacer (no box), 'empty' = transparent box, 'white' = white box, icon key = icon box
type Cell =
  | null
  | 'empty'
  | 'white'
  | 'zap'
  | 'github'
  | 'cube'
  | 'notion'
  | 'vscode'
  | 'wordpress'
  | 'slack'
  | 'figma'
  | 'google'
  | 'sparkle'
  | 'cursor'

const ICON_MAP: Record<string, ReactNode> = {
  zap: <ZapIcon />,
  github: <GithubIcon />,
  cube: <CubeIcon />,
  notion: <NotionIcon />,
  vscode: <VSCodeIcon />,
  wordpress: <WordPressIcon />,
  slack: <SlackIcon />,
  figma: <FigmaIcon />,
  google: <GoogleIcon />,
  sparkle: <SparkleIcon />,
  cursor: <CursorIcon />,
}

// 9 columns × 5 rows — null = no box (empty gap), last row is half-cut
const GRID: Cell[] = [
  // col0      col1   col2      col3   col4    col5    col6      col7      col8
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  'sparkle',
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  'white',
  'empty',
  'github',
  null,
  null,
  null,
  null,
  'cursor',
  'empty',
  null,
  'notion',
  null,
  'empty',
  null,
  'vscode',
  null,
  null,
  'empty',
  'wordpress',
  null,
  null,
  'slack',
  'empty',
  'white',
  'figma',
  null,
  null,
  'empty',
  null,
  null,
  null,
  null,
  'empty',
  null,
  'white',
  'zap',
  null,
  null,
  'google',
  'white',
  'cube',
  null,
  'empty',
  'empty',
  null,
  'empty',
  null,
]

// ─── Card 2 timeline items ────────────────────────────────────────────────────
const timelineItems = [
  {
    label: 'initiateproject ( )',
    duration: '125d',
    bg: '#D6F5EC',
    color: '#2A7A5A',
    border: '#AADFC8',
  },
  {
    label: 'analysis()',
    duration: '25d',
    bg: '#FFE2DC',
    color: '#C4402A',
    border: '#F9BFB5',
    width: '37%',
    ml: '0%',
  },
  {
    label: 'fetchdesign()',
    duration: '35d',
    bg: '#D6F5F5',
    color: '#0E7A7A',
    border: '#A8E0E0',
    width: '52%',
    ml: '18%',
  },
  {
    label: 'validate()',
    duration: '50d',
    bg: '#F5F5D6',
    color: '#6A6A10',
    border: '#D8D8A0',
    width: '56%',
    ml: '38%',
  },
  {
    label: 'testcomponent()',
    duration: '10d',
    bg: '#E4F5E4',
    color: '#2A6A2A',
    border: '#A8D8A8',
    width: '56%',
    ml: '38%',
  },
]

const ExpandIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
    <path
      d="M9 1H15C15.5523 1 16 1.44772 16 2V8"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M8 17L2 17C1.44771 17 1 16.5523 1 16L1 10"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)

// ─── Card 1 ───────────────────────────────────────────────────────────────────
function TechBackofficeCard() {
  const navigate = useNavigate()
  let iconIdx = 0

  return (
    <motion.div
      onClick={() => void navigate('/back-office')}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="relative flex w-full max-w-[611px] flex-col overflow-hidden rounded-[10px] border border-[#E8E8E8] bg-[rgba(255,255,255,0.60)] shadow-[0_4px_54px_0_rgba(255,255,255,0.24)] backdrop-blur-[10.8px] h-[450px] xl:h-[575px]"
      style={{
        cursor: 'pointer',
        backgroundImage: `url(${bg1})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="flex items-start justify-between p-5 pb-3 lg:p-6 lg:pb-4">
        <div>
          <h3 className="font-sans text-[20px] font-medium not-italic leading-normal tracking-[-1px] text-[#2D2D2D] sm:text-[24px] lg:text-[32px]">
            Technology Backoffice.
          </h3>
          <p className="mt-1.5 font-sans text-[13px] font-normal not-italic leading-normal tracking-[-1px] text-[#979AC0] sm:text-[16px] lg:max-w-[417px] lg:text-[24px]">
            An integrated team acting as your internal tech unit.
          </p>
        </div>
        <button aria-label="Expand Technology Backoffice section" className="box-border flex h-12 w-12 shrink-0 items-center justify-center gap-[10px] rounded-[4px] border border-[#D6D9FC] bg-white pt-4 pr-[17px] pb-4 pl-4 text-[#555]">
          <ExpandIcon />
          <span className="sr-only">Expand Technology Backoffice section</span>
        </button>
      </div>

      {/* 9-col grid — overflow-hidden clips last row to ~half */}
      <div className="w-full max-w-[547px] mx-auto overflow-hidden h-auto lg:h-[423px] grid grid-cols-5 sm:grid-cols-9 gap-1 lg:gap-2.5 px-3 xl:px-0">
        {GRID.map((cell, i) => {
          const baseStyle: React.CSSProperties = {
            borderRadius: '13.478px',
            border: '1.123px solid rgba(230, 230, 230, 0.46)',
            backdropFilter: 'blur(12.13px)',
            height: '52px',
            width: '100%',
          }

          if (cell === null) {
            return <div key={i} />
          }

          if (cell === 'empty') {
            return <div key={i} style={{ ...baseStyle, background: 'rgba(230, 230, 230, 0.26)' }} />
          }

          if (cell === 'white') {
            return <div key={i} style={{ ...baseStyle, background: '#F5F5F5' }} />
          }

          // Icon cell — loops: fade-in → hold → fade-out → repeat
          const delay = iconIdx++ * 0.35
          return (
            <div
              key={i}
              className="flex items-center justify-center"
              style={{
                ...baseStyle,
                background: 'rgba(230, 230, 230, 0.26)',
                // boxShadow: '0 0 8.986px 0 rgba(44, 44, 44, 0.10)',
                padding: '11.232px 10.109px',
              }}
            >
              <motion.div
                animate={{ opacity: [0, 1, 1, 0], scale: [0.4, 1, 1, 0.4] }}
                transition={{
                  duration: 2.2,
                  delay,
                  repeat: Infinity,
                  repeatDelay: 0.6,
                  ease: 'easeInOut',
                  times: [0, 0.2, 0.75, 1],
                }}
                className="flex items-center justify-center shrink-0"
              >
                {ICON_MAP[cell]}
              </motion.div>
            </div>
          )
        })}
      </div>
    </motion.div>
  )
}

// ─── Card 2 ───────────────────────────────────────────────────────────────────
function ProductEngineeringCard() {
  const navigate = useNavigate()

  return (
    <motion.div
      onClick={() => void navigate('/product-engineering')}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: 0.1 }}
      className="relative flex h-auto w-full max-w-[611px] flex-col overflow-hidden rounded-[10px] border border-[#E8E8E8] bg-[rgba(255,255,255,0.60)] shadow-[0_4px_54px_0_rgba(255,255,255,0.24)] backdrop-blur-[10.8px] lg:h-[575px]"
      style={{
        cursor: 'pointer',
        backgroundImage: `url(${bg2})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="flex items-start justify-between p-5 pb-3 lg:p-6 lg:pb-[44px]">
        <div>
          <h3 className="font-sans text-[20px] font-medium not-italic leading-normal tracking-[-1px] text-[#2D2D2D] sm:text-[24px] lg:text-[32px]">
            Product Engineering
          </h3>
          <p className="mt-1.5 font-sans text-[13px] font-normal not-italic leading-normal tracking-[-1px] text-[#979AC0] sm:text-[16px] lg:max-w-[417px] lg:text-[24px]">
            End-to-end product development from idea to launch.
          </p>
        </div>
        <button aria-label="Expand Product Engineering section" className="box-border flex h-12 w-12 shrink-0 items-center justify-center gap-[10px] rounded-[4px] border border-[#D6D9FC] bg-white pt-4 pr-[17px] pb-4 pl-4 text-[#555]">
          <ExpandIcon />
          <span className="sr-only">Expand Product Engineering section</span>
        </button>
      </div>

      <div className="flex flex-col gap-4 mx-3 sm:mx-6">
        {/* Complete card — headers + complete row together */}
        <div className="flex w-full max-w-[547px] mx-auto flex-col items-start gap-[10px] rounded-[10px] border border-[rgba(207,207,207,0.70)] bg-[rgba(207,207,207,0.14)] p-[10px] backdrop-blur-[3.3px]">
          <div className="w-full flex items-center justify-between">
            <span className="font-sans text-[12px] font-normal not-italic leading-[150%] tracking-[-0.176px] text-[#8F8585] sm:text-[14px] lg:text-[16px]">
              Status
            </span>
            <span className="font-sans text-[12px] font-normal not-italic leading-[150%] tracking-[-0.176px] text-[#8F8585] sm:text-[14px] lg:text-[16px]">
              Duration
            </span>
          </div>
          <div className="w-full flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-green-500" />
              <span className="font-sans text-[12px] font-normal not-italic leading-[150%] tracking-[-0.176px] text-black sm:text-[14px] lg:text-[16px]">
                Complete
              </span>
            </div>
            <span className="font-sans text-[12px] font-normal not-italic leading-[150%] tracking-[-0.176px] text-black sm:text-[14px] lg:text-[16px]">
              125d
            </span>
          </div>
        </div>

        {/* Animated rows — staggered entrance, loops continuously */}
        {timelineItems.map((item, i) => {
          // Bake stagger into keyframe times so the loop is always in sync.
          // T=6s cycle: row i enters at i*0.5s, all hold until 4.5s, all exit by 5.5s.
          const T = 6
          const s0 = (i * 0.5) / T // enter start (fraction)
          const s1 = s0 + 0.06 // enter end
          const hold = 4.5 / T // 0.75
          const exit = 5.5 / T // 0.917
          return (
            <motion.div
              key={item.label}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: [0, 0, 1, 1, 0, 0], y: [20, 20, 0, 0, 0, 20] }}
              transition={{
                duration: T,
                repeat: Infinity,
                repeatDelay: 0.8,
                ease: 'easeInOut',
                times: [0, s0, s1, hold, exit, 1],
              }}
              className={
                i === 0
                  ? 'flex w-full max-w-[547px] mx-auto items-center justify-between rounded-[10px] border border-[#90DFE4] bg-[rgba(144,223,228,0.26)] p-[10px] backdrop-blur-[19.5px]'
                  : i === 1
                    ? 'flex w-full max-w-[127px] items-center justify-between rounded-[10px] border border-[rgba(244,138,138,0.60)] bg-[rgba(244,138,138,0.23)] p-[10px] backdrop-blur-[4.2px] ml-2'
                    : i === 2
                      ? 'flex w-full max-w-[153px] items-center justify-between rounded-[10px] border border-[rgba(102,204,255,0.60)] bg-[rgba(102,204,255,0.19)] p-[10px] backdrop-blur-[4.2px] ml-[60px] sm:ml-[100px] lg:ml-[130px]'
                      : i === 3
                        ? 'flex w-full max-w-[193px] items-center justify-between rounded-[10px] border border-[rgba(212,207,75,0.70)] bg-[rgba(255,251,116,0.16)] p-[10px] backdrop-blur-[6.6px] ml-[100px] sm:ml-[190px] lg:ml-[280px]'
                        : i === 4
                          ? 'flex w-full max-w-[267px] items-center justify-between rounded-[10px] border border-[rgba(238,181,83,0.70)] bg-[rgba(238,181,83,0.36)] p-[10px] backdrop-blur-[3.3px] ml-[100px] sm:ml-[190px] lg:ml-[280px]'
                          : 'flex items-center justify-between rounded-[8px] px-3 py-2'
              }
            >
              <span
                className={
                  i === 0
                    ? 'font-sans text-[11px] font-normal not-italic leading-[150%] tracking-[-0.176px] text-[#80CACF] sm:text-[13px] lg:text-[16px]'
                    : i === 1
                      ? 'font-sans text-[11px] font-normal not-italic leading-[150%] tracking-[-0.176px] text-[#F48A8A] sm:text-[13px] lg:text-[16px]'
                      : i === 2
                        ? 'font-sans text-[11px] font-normal not-italic leading-[150%] tracking-[-0.176px] text-[#66CCFF] sm:text-[13px] lg:text-[16px]'
                        : i === 3
                          ? 'font-sans text-[11px] font-normal not-italic leading-[150%] tracking-[-0.176px] text-[#D4CF4B] sm:text-[13px] lg:text-[16px]'
                          : i === 4
                            ? 'font-sans text-[11px] font-normal not-italic leading-[150%] tracking-[-0.176px] text-[#E1AC50] sm:text-[13px] lg:text-[16px]'
                            : 'font-mono text-[12px] font-medium'
                }
              >
                {item.label}
              </span>
              <span
                className={
                  i === 0
                    ? 'font-sans text-[11px] font-normal not-italic leading-[150%] tracking-[-0.176px] text-[#80CACF] sm:text-[13px] lg:text-[16px]'
                    : i === 1
                      ? 'font-sans text-[11px] font-normal not-italic leading-[150%] tracking-[-0.176px] text-[#F48A8A] sm:text-[13px] lg:text-[16px]'
                      : i === 2
                        ? 'font-sans text-[11px] font-normal not-italic leading-[150%] tracking-[-0.176px] text-[#66CCFF] sm:text-[13px] lg:text-[16px]'
                        : i === 3
                          ? 'font-sans text-[11px] font-normal not-italic leading-[150%] tracking-[-0.176px] text-[#D4CF4B] sm:text-[13px] lg:text-[16px]'
                          : i === 4
                            ? 'font-sans text-[11px] font-normal not-italic leading-[150%] tracking-[-0.176px] text-[#E1AC50] sm:text-[13px] lg:text-[16px]'
                            : 'font-sans text-[12px]'
                }
              >
                {item.duration}
              </span>
            </motion.div>
          )
        })}
      </div>
    </motion.div>
  )
}

// ─── Main export ──────────────────────────────────────────────────────────────
export function ServicesSection() {
  return (
    <section
      id="services"
      className="bg-white pt-12 sm:pt-16 lg:pt-[250px]"
      aria-label="Our Services"
    >
      <div className="container-site">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-8 flex flex-col gap-3 sm:gap-4 lg:mb-10 lg:gap-6"
        >
          <span className="font-sans text-[13px] font-bold uppercase tracking-[0.061px] text-[#D4575B] sm:text-[15px] lg:text-[18px]">
            Our Pillars
          </span>
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between lg:gap-6">
            <h2 className="max-w-[955px] font-sans text-[26px] font-medium leading-[30px] tracking-[-0.5px] sm:text-[34px] sm:leading-[38px] md:text-[40px] md:leading-[44px] lg:text-[48px] lg:leading-[55px] lg:tracking-[-1px]">
              <span className="text-[#2D2D2D]">From Embedded Teams to Product Delivery.</span>{' '}
              <span className="text-[#979AC0]">
                Services designed around long-term growth and reliable execution.
              </span>
            </h2>
            {/* <div className="shrink-0">
                            <a
                                href="#"
                                className="inline-flex items-center justify-center gap-[10px] rounded-[10px] border border-[rgba(41,41,41,0.09)] bg-[#302F2F] p-4 text-center font-sans text-[18px] font-normal not-italic leading-normal text-white transition-colors hover:bg-black"
                                style={{ leadingTrim: 'both', textEdge: 'cap' } as React.CSSProperties}
                            >
                                See More Projects
                            </a>
                        </div> */}
          </div>
        </motion.div>

        {/* Two service cards */}
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6 w-full">
          <TechBackofficeCard />
          <ProductEngineeringCard />
        </div>

        {/* Get on a call banner */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mt-5 flex flex-col overflow-hidden rounded-[10px] border border-[#F4EEEE] bg-white sm:flex-row sm:items-center lg:mt-6 lg:h-[186px]"
        >
          <div className="flex flex-1 flex-col gap-3 p-6 lg:gap-4 lg:p-8">
            <h3 className="font-sans text-[18px] font-medium not-italic leading-normal tracking-[-1px] text-[#1C1917] sm:text-[22px] lg:text-[32px]">
              Not sure which approach fits your needs?
            </h3>
            <p className="font-sans text-[13px] font-normal not-italic leading-normal tracking-[-1px] text-[#74828F] sm:text-[15px] lg:text-[24px]">
              We'll help you choose the right path based on your product and business goals.
            </p>
          </div>
          {/* Right: image with button overlaid on top */}
          <div className="relative h-[100px] shrink-0 sm:h-auto sm:w-[200px] sm:self-stretch lg:w-[260px]">
            <img
              src={callImg}
              alt=""
              aria-hidden="true"
              className="h-full w-full object-cover object-left"
            />
            <Link
              to="/contact"
              className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 inline-flex items-center justify-center whitespace-nowrap rounded-[10px] bg-white px-5 py-3 text-center font-sans text-[16px] font-normal not-italic leading-normal text-[#292929] shadow-[0_4px_16px_0_rgba(0,0,0,0.10)] transition-colors hover:bg-gray-50"
            >
              Get on a call
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
